<div class="flex items-center mt-10 -mx-6 sm:-mx-12 py-4 pr-4 pl-1 sm:pr-12 sm:pl-7 border-t bg-gray-50 dark:bg-transparent">

    <button class="ml-2" mat-button color="primary" [disabled]="isDisabled" tabindex="1" (click)="saveButtonClicked()"
       [loading]="isRequesting">
        <fa-icon [icon]="['fal', 'save']" class="mr-2"></fa-icon>
        {{'SYSTEM.RECORD.SAVE' | translate}}
    </button>

    <button class="ml-auto" type="button" mat-button color="warn"  (click)="returlUrlClicked()">
        <fa-icon [icon]="['fal', 'times']" class="mr-2"></fa-icon>
        {{'SYSTEM.RECORD.CANCEL' | translate}}
    </button>

</div>
